import React from 'react';
import hint from '../../../assets/sso/Hint.svg';

const Help: React.FC = () => {
    const url = 'https://www.calameo.com/read/006173559fc8f115c9c21';

    const openLink = () => {
        window.open(url, '_blank');
    };

    return (
        <div>
            <div className="flex items-center justify-start gap-2 w-full relative">
                <img src={hint} alt="hint icon" />
                <div>Besoin d'aide ?</div>
            </div>
            <button
                onClick={openLink}
                className="block text-black px-4 py-2 text-medium leading-[1.5] rounded-[1.5rem] font-medium bg-[#F2F6CC] absolute bottom-8"
            >
                Voir le guide d'utilisation
            </button>
        </div>
    );
};

export default Help;
